import type { Article, CardDeck } from "../../services/educationService";

export interface DerivedVideoMeta {
	/** Article intro, reused as the video description. */
	description: string;
	/** Card-deck questions, reused as the "In this video" bullets. */
	bullets: string[];
	/** Disclaimer carried by the article, when it has one. */
	disclaimer: string;
}

/**
 * era-api exposes no sidecar meta for the generated video (no DB column), so —
 * exactly like `derivePodcastMeta` does for the podcast — we derive what the
 * viewer shows from the artefacts we already fetch: the article intro becomes
 * the description and the card questions become the chapter bullets.
 */
export function deriveVideoMeta(
	article: Article | null,
	deck: CardDeck | null,
): DerivedVideoMeta {
	return {
		description: article?.intro ?? "",
		bullets: deck?.cards.map((c) => c.question) ?? [],
		disclaimer: article?.disclaimer ?? "",
	};
}
